module.exports = __webpack_public_path__ + "static/media/bc5cdr.33ada740.png";